import { IFormType } from "../../model/formconfiguration/FormType";
import { IFormTypeService } from "../../service/formconfiguration/FormTypeService";

export default class CreateFormTypeInteractor {
  private formTypeService: IFormTypeService;

  constructor(formTypeService) {
    this.formTypeService = formTypeService;
  }

  async execute(formType: IFormType) {
    return this.formTypeService.createFormType(formType);
  }
}
